var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V48C56 52.4183 52.4183 56 48 56H8C3.58172 56 0 52.4183 0 48V8Z",
    fill: "#22AD80",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5625 18.1042C32.0349 18.1042 32.488 18.3127 32.822 18.6839C33.1561 19.055 33.3437 19.5584 33.3437 20.0833V35.9167C33.3437 36.4416 33.1561 36.945 32.822 37.3161C32.488 37.6873 32.0349 37.8958 31.5625 37.8958H24.4375C23.9651 37.8958 23.512 37.6873 23.178 37.3161C22.8439 36.945 22.6562 36.4416 22.6562 35.9167V20.0833C22.6562 19.5584 22.8439 19.055 23.178 18.6839C23.512 18.3127 23.9651 18.1042 24.4375 18.1042H31.5625ZM24.4375 16.125C23.4927 16.125 22.5865 16.542 21.9184 17.2844C21.2503 18.0267 20.875 19.0335 20.875 20.0833V35.9167C20.875 36.9665 21.2503 37.9733 21.9184 38.7156C22.5865 39.458 23.4927 39.875 24.4375 39.875H31.5625C32.5073 39.875 33.4135 39.458 34.0816 38.7156C34.7497 37.9733 35.125 36.9665 35.125 35.9167V20.0833C35.125 19.0335 34.7497 18.0267 34.0816 17.2844C33.4135 16.542 32.5073 16.125 31.5625 16.125H24.4375Z",
    fill: "#22AD80"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 33.9375,
    r: 2.375,
    fill: "#22AD80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtime);
export default __webpack_public_path__ + "static/media/airtime.64ecaf0faa4ae00d3f7e0fc13ab7f282.svg";
export { ForwardRef as ReactComponent };